import gql from 'graphql-tag';

const BETSHOP_SELECTION = `{
  _id
  name
  logo
  type
  provider
  pages {
    name
    slug
    layout {
      name
    }
    content {
      leftSidebar {
        visibleInLayouts
        content {
          id
          name
          availableIn
          component
          settings
        }
      }
      main {
       visibleInLayouts
       content {
         id
         type
         content {
             first {
               id
               name
               availableIn
               component
               settings
             }
             second {
               id
               name
               availableIn
               component
               settings
             }
           }
         }
      }
      rightSidebar {
        visibleInLayouts
        content {
          id
          name
          availableIn
          component
          settings
        }
      }
    }
  }
  colorScheme
  header
  footer
  activeTheme {
    _id
    name
    colorScheme
    layouts {
      name
    }
  }
}
`;

export const GET_BETSHOP = gql`
  query betshop($_id: String!) {
    betshop(_id: $_id) ${BETSHOP_SELECTION}
  }
`;
